import {
  InputField,
  InputSelectOptions
} from 'components/molecules'
import {
  INPUT_FORMATS,
  NOTIFICATION_RECEIVERS,
  CUSTOMER_ATTRIBUTES,
  SELLER_ATTRIBUTES,
  USER_ATTRIBUTES
} from 'domains/announcements/constants'
import PropTypes from 'prop-types'

const propTypes = {
  index                        : PropTypes.number,
  onUpdateAttributeAfterChange : PropTypes.func,
  receiver                     : PropTypes.string,
  currentDynamicContent        : PropTypes.object,
  csvColumns                   : PropTypes.array,
  fieldName                    : PropTypes.string
}

const ATTRIBUTE_OPTIONS = {
  [NOTIFICATION_RECEIVERS.USER]     : USER_ATTRIBUTES,
  [NOTIFICATION_RECEIVERS.CUSTOMER] : CUSTOMER_ATTRIBUTES,
  [NOTIFICATION_RECEIVERS.SELLER]   : SELLER_ATTRIBUTES
}

const DynamicContentRowInputField = ({
  index,
  onUpdateAttributeAfterChange,
  receiver,
  currentDynamicContent,
  csvColumns,
  fieldName
}) => {
  const showCsvOptionGroup = csvColumns.length > 0
  return (
    <div className='d-flex align-items-center small'>
      <strong className='mr-1'>
        { `{{${index+1}}} ` }
      </strong>
      <InputField
        type='select'
        name={ `${fieldName}[${index}].attribute` }
        label='Attribute'
        required={ true }
        onChange={ (event) => onUpdateAttributeAfterChange(event, index)  }
        formGroupClassName='mr-2'
        bsSize={ 'sm' }
      >
        <optgroup label="Receiver">
          <InputSelectOptions
            options={ ATTRIBUTE_OPTIONS[receiver] }
            keyPrefix={ `${fieldName}[${index}]-attribute` }
          />
        </optgroup>
        {
          showCsvOptionGroup && (
            <optgroup label="CSV Resource">
              {
                csvColumns.map((columnName) => (
                  <option
                    key={ `${fieldName}[${index}]-csv-${columnName}` }
                    value={ columnName }
                  >
                    { columnName }
                  </option>
                ))
              }
            </optgroup>
          )
        }
        <option key='manual' value='manual'>Manual Input</option>
      </InputField>
      <InputField
        label="value"
        type='text'
        formGroupClassName='mr-2'
        required={ true }
        name={ `${fieldName}[${index}].value` }
        disabled={ currentDynamicContent.attribute !== 'manual' }
        bsSize={ 'sm' }
      />
      <InputField
        type='select'
        name={ `${fieldName}[${index}].formatting` }
        label='Format'
        required={ true }
        bsSize={ 'sm' }
      >
        <InputSelectOptions
          options={ INPUT_FORMATS }
          keyPrefix={ `${fieldName}[${index}]-formatting` }
        />
      </InputField>
    </div>
  )
}

DynamicContentRowInputField.propTypes = propTypes

export default DynamicContentRowInputField
